import { Outlet } from 'react-router-dom'

const NoLayout = () => <Outlet />

export default NoLayout
